import { FC } from 'react';
import { Typography, useTheme } from '@mui/material';
import EmptyListIcon from '@img/empty-list.svg';
import * as Styled from './styled';

export const NoDataOverlay: FC = () => {
  const theme = useTheme();

  const text = (theme?.components as any)?.MuiDataGrid.defaultProps.localeText
    .noRowsLabel;

  return (
    <Styled.Container>
      <EmptyListIcon />
      <Typography variant="body1" color="text.secondary">
        {text}
      </Typography>
    </Styled.Container>
  );
};
